<template>
  <div class="page-reset-password">
    <mod-web-header title="用户密码重置" :status="1" />
    <mod-user-status v-if="success" title="重置密码成功，请重新登录！" :status="-10" />
    <div v-else class="wrapper">
      <form class="reset-password-box" @submit.prevent="onSubmit">
        <div class="title">用户密码重置</div>
        <z-input
          v-model.trim="mobile"
          class="item"
          :width="282"
          placeholder="请输入手机号"
          @input="onMobileInput"
          @focus="onFocus('mobile')"
        />
        <p :class="$addClass('error', [!errors.mobile, 'hide'])">* {{ errors.mobile }}</p>
        <div class="item">
          <z-input
            v-model.trim="pin"
            :width="162"
            placeholder="请输入6位验证码"
            @focus="onFocus('pin')"
          />
          <z-verification :mobile="mobile" type="reset" @error="onError" @success="onSuccess" />
        </div>
        <p v-if="pinSuccess" class="success-text">* {{ pinSuccess }}</p>
        <p v-else :class="$addClass('error', [!errors.pin, 'hide'])">* {{ errors.pin }}</p>
        <z-input
          v-model.trim="password"
          class="item"
          type="password"
          :width="282"
          placeholder="请输入6-20位字母和数字组合密码"
          autocomplete="new-password"
          @focus="onFocus('password')"
        />
        <p :class="$addClass('error', [!errors.password, 'hide'])">* {{ errors.password }}</p>
        <z-input
          v-model.trim="confirmation"
          class="item"
          type="password"
          :width="282"
          placeholder="请再次输入新密码确认"
          @focus="onFocus('confirmation')"
        />
        <p v-if="errorText" class="error-text">{{ errorText }}</p>
        <p v-else :class="$addClass('error', [!errors.confirmation, 'hide'])">
          * {{ errors.confirmation }}
        </p>
        <button class="submit-button" type="submit">开始重置密码</button>
      </form>
    </div>
    <mod-web-footer />
    <com-copyright />
  </div>
</template>

<script>
import ModWebHeader from '@/components/mod-web-header'
import ModWebFooter from '@/components/mod-web-footer'
import ModUserStatus from '@/components/mod-user-status'
import ComCopyright from '@/components/com-copyright'
import ZVerification from '@/components/z-verification'
import { regExp } from '@/utils'
import { resetPassword } from '@/data'

export default {
  name: 'ResetPassword',
  components: {
    ModWebHeader,
    ModWebFooter,
    ModUserStatus,
    ComCopyright,
    ZVerification
  },
  data() {
    return {
      success: false,
      mobile: '',
      pin: '',
      password: '',
      confirmation: '',
      errors: {},
      errorText: '',
      pinSuccess: ''
    }
  },
  methods: {
    onMobileInput() {
      this.mobile = this.mobile.substr(0, 11).replace(/[^0-9]/g, '')
    },
    onFocus(name) {
      const errors = { ...this.errors }
      errors[name] = ''
      this.errors = errors
      this.errorText = ''
      this.pinSuccess = ''
    },
    onError(error) {
      const errors = {}
      errors[error.field] = error.message
      this.errors = errors
      this.pinSuccess = ''
      this.errorText = ''
    },
    onSuccess(message) {
      this.errors = {}
      this.pinSuccess = message
      this.errorText = ''
    },
    async onSubmit() {
      const { mobile, pin, password, confirmation } = this
      let errors = {}

      if (!mobile) {
        errors.mobile = '请输入手机号'
      }

      if (!regExp.MOBILE.test(mobile)) {
        errors.mobile = '请输入正确的手机号'
      }

      if (!pin) {
        errors.pin = '请输入验证码'
      }

      if (!password) {
        errors.password = '请输入密码'
      }

      if (!regExp.PASSWORD.test(password)) {
        errors.password = '请输入6-20位字母和数字组合密码'
      }

      if (!confirmation) {
        errors.confirmation = '请再次输入密码'
      }

      if (password !== confirmation) {
        errors.confirmation = '两次输入的密码不一致，请重新输入'
      }

      this.pinSuccess = ''

      if (Object.keys(errors).length > 0) {
        this.errors = errors
        return
      }

      const data = await resetPassword({ mobile, pin, password, confirmation })

      if (data.error_code === 0) {
        document.title = '重置成功 - 纵购商城'
        this.success = true
      } else if (data.errors.length > 0) {
        data.errors.forEach((item) => {
          errors[item.field] = item.message
        })
      } else {
        this.errorText = data.message
      }

      this.errors = errors
    }
  }
}
</script>

<style lang="postcss">
.page-reset-password {
  .wrapper {
    height: 520px;
    padding: 65px 0;
    background-color: #fff;
  }

  .reset-password-box {
    width: 332px;
    padding: 25px;
    margin: 0 auto;

    .title {
      line-height: 36px;
      border-bottom: 1px solid #ccc;
      margin-bottom: 5px;
      text-align: center;
      font-size: 18px;
    }

    .z-input {
      height: 38px;
      line-height: 28px;
    }

    .item {
      margin-top: 10px;
      width: 100%;

      button {
        border: none;
        background-color: #ccc;
        height: 38px;
        font-size: 12px;
        color: #666;
        margin-left: 10px;
        width: 110px;
        border-radius: 5px;
        cursor: pointer;
      }
    }

    .error,
    .error-text,
    .success-text {
      font-size: 12px;
      padding: 0 5px;
      color: #c81613;
      height: 18px;

      &.hide {
        visibility: hidden;
      }
    }

    .error-text {
      margin-top: 10px;
    }

    .success-text {
      color: #19be6b;
    }

    .submit-button {
      height: 44px;
      background-color: #fabe00;
      border: none;
      width: 100%;
      border-radius: 5px;
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>
